import styled from 'styled-components';

export const PanelActions = styled.div`
  display: flex;
  gap: 10px;
`;
